import React, { useEffect, useState } from "react";
import { Card, Spinner, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CustomPagination from "Common/customPagination";
import { authServices } from "Utils/auth/services";

import PlUserwiseTableEventtable from "Common/Tables/eventPlTables/plUserwiseTable";

interface UserWisePlPayload {
  page: number;
  limit: number;
  market_id: string | undefined;
}

const PlUserwise: React.FC = () => {
  const { event_id, type } = useParams<any>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [casinoBetsData, setCasinoBetsData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(50);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const getEventPlData = async (page: number = 1) => {
    if (!event_id) return;

    setIsLoading(true);
    try {
      const payload: UserWisePlPayload = {
        page,
        limit: itemsPerPage,
        market_id: event_id,
      };

      const { response } = await authServices.getUsersPLByMarket(payload);
      const metadata = response?.metadata;

      if (response?.data) {
        setCasinoBetsData(response.data);
        setTotalItems(metadata?.[0]?.total || 0);
      } else {
        setCasinoBetsData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching userwise PL data:", error);
      setCasinoBetsData([]);
      setTotalItems(0);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = Number(event.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // reset to first page when limit changes
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredData = casinoBetsData.filter((item) => {
    return (
      item.user_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.sport_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.match_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.market_name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  useEffect(() => {
    getEventPlData(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, itemsPerPage, event_id]);

  const handleRowClick = (
    match_id: string,
    match_name: string,
    sport_name: string,
    user_id: string
  ) => {
    // Construct the URL for the bet details page
    const url = `/pl-UserBet/${match_id}/${event_id}/${match_name}/${sport_name}/${user_id}/${type}`;
    // Open the new page
    window.open(url, "_blank");
  };
  return (
    <div className="event-pl">
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2 align-items-center">
              Show
              <select
                className="form-select w-auto"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
              </select>
              Entries
            </div>

            <Form.Control
              type="text"
              placeholder="Search user, sport, market..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="w-25"
            />
          </div>

          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <>
              <PlUserwiseTableEventtable
                fancyPLData={filteredData} // Use filtered data for display
                onClickRow={handleRowClick}
              />
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PlUserwise;
